import AbstractShapeMode from "./AbstractShapeMode";
import { onCanvas } from "../../shared/mouseFunctions";
import Ellipse from "../shapes/Ellipse";
import { DRAW } from "../../tools/actions/ActionHelper";

export default class EllipseMode extends AbstractShapeMode {
    firstCoordinate = null;
    size = null;

    display(g) {
        if (this.firstCoordinate) {
            if (this.touch || !onCanvas(this.provider)) {
                this.firstCoordinate.display(g);
            } else {
                this.drawMenu.appearance.apply(g);
                g.ellipse(this.firstCoordinate.currentX, this.firstCoordinate.currentY, this.size);
            }
        }
    }

    activate() {
        this.input.setDrawMode('ellipse');
        this.drawMenu.enableFill();
        this.drawMenu.hideSegmentTypeSelector();
        this.drawMenu.showCanopyStyleSelector();
    }

    pressMouseOnCanvas() {
        if (!this.firstCoordinate) {
            this.firstCoordinate = this.view.snappedCoordinate;
            this.input.showDimensions();
        } else {
            this.setSize();
            this.makeShape();
        }
    }

    makeShape() {
        if (!this.firstCoordinate) {
            return;
        }
        if (this.currentSize < 5) {
            this.warn('That ellipse is too small. Click further from the center to set its size.');
            return;
        }
        let canopyStyle = this.drawMenu.canopyStyle;
        let ellipse = new Ellipse(
            this.provider,
            {
                x: this.firstCoordinate.absX,
                y: this.firstCoordinate.absY,
                width: this.size / this.view.scale,
                height: this.size / this.view.scale,
                canopyStyle: canopyStyle !== 'smooth' ? canopyStyle : undefined,
                canopySeed: canopyStyle !== 'smooth' ? Math.floor(Math.random() * 100000) : undefined,
                layer: this.layer,
                addedDate: this.addedDate,
                removedDate: this.removedDate,
            },
            this.drawMenu.appearance.clone(),
            this.speciesIds,
            this.labels
        );
        this.actions.execute(DRAW, ellipse);
        this.reset();
    }

    setSize() {
        this.size = this.sticky['size']
            ? this.sticky['size'].value() * this.view.scale
            : this.currentSize;
        if (!this.sticky['size']) {
            this.input.size.value(this.firstCoordinate.distanceTo(this.view.snappedCoordinate) * 2);
        }
    }

    mouseMoved() {
        if (this.firstCoordinate) {
            this.setSize();
        }
    }

    reset() {
        super.reset();
        this.firstCoordinate = null;
        this.size = null;
    }

    getTips() {
        if (this.touch) {
            if (!this.firstCoordinate) {
                return 'Tap to place the center of the ellipse.';
            }
            return 'Tap to set the size of the ellipse.';
        }
        if (!this.firstCoordinate) {
            return 'Click to place the center of the ellipse.';
        }
        return 'Click to place the outer boundary. Press Z to change the size.';
    }

    get currentSize() {
        return this.firstCoordinate.currentDistanceTo(this.view.snappedCoordinate) * 2;
    }

    get absSize() {
        return this.firstCoordinate.absDistanceTo(this.view.snappedCoordinate) * 2;
    }

    pressKey(code) {
        switch (code) {
            case 90: // Z
                focusInput(this.getInput('size'));
                return;
        }
    }
}
